module.exports = __webpack_public_path__ + "img/huifa-note.47cd4383.png";